/**
 * @param ?string id
 * @param string text
 * @param int votes
 */
export default class PollAnswer
{
  constructor({
    id = null,
    text = '',
    votes = 0,
  }) {
    this.id = id;
    this.text = text;
    this.votes = votes;
  }
};
